import Api from "../api";
import { Instance } from "@/services/instances/types";

export async function getInstances(): Promise<Array<Instance>> {
    return new Promise((resolve, reject) => {
        Api.get("/instance").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getOneTimeToken(id: string): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.get(`/instance/getOneTimeToken/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
